import css from "./TagsIcons.module.scss";

const Web = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<circle cx="12" cy="12" r="10" />
		<path d="M2 12h20" />
		<path d="M12 2a15.3 15.3 0 0 1 0 20" />
		<path d="M12 2a15.3 15.3 0 0 0 0 20" />
	</svg>
);

const Design = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<path d="M12 20h9" />
		<path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
	</svg>
);

const Javascript = () => (
	<svg className={`${css._} ${css.full} ${css.js}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<circle cx="100" cy="100" r="100" fill="#f7df1e" stroke="none" />
		<text x="87%" y="67%" fill="black">
			JS
		</text>
	</svg>
);

const Typescript = () => (
	<svg className={`${css._} ${css.full} ${css.ts}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<circle cx="100" cy="100" r="100" fill="#3178C6" stroke="none" />
		<text x="87%" y="67%" fill="white">
			TS
		</text>
	</svg>
);

const React = () => (
	<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<circle cx="100" cy="100" r="10" fill="#61DAFB" stroke="none" />
		<g stroke="#61DAFB" strokeWidth="10">
			<ellipse cx="100" cy="100" rx="85" ry="35" />
			<ellipse cx="100" cy="100" rx="85" ry="35" transform="rotate(60 100 100)" />
			<ellipse cx="100" cy="100" rx="85" ry="35" transform="rotate(120 100 100)" />
		</g>
	</svg>
);

const Game = () => (
	<svg
		className={`${css._} ${css.game}`}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<rect x="1" y="6" width="22" height="12" rx="6" ry="6" />

		<line x1="3.5" y1="12" x2="8.5" y2="12" />
		<line x1="6" y1="9.5" x2="6" y2="14.5" />

		<circle cx="17" cy="10" r="0.85" />
		<circle cx="19" cy="12" r="0.85" />
		<circle cx="15" cy="12" r="0.85" />
		<circle cx="17" cy="14" r="0.85" />

		<line x1="10" y1="7.75" x2="14" y2="7.75" />
	</svg>
);

export const TagsIcons = {
	web: Web,
	design: Design,
	javascript: Javascript,
	typescript: Typescript,
	react: React,
	game: Game,
};
